<template>
  <div class="py-3 md:py-4">
    <div class="md:container px-4">
      <div class="flex flex-wrap md:flex-nowrap justify-between items-center">
        <div class="">
          <img
            v-lazy-load data-src="@/assets/icon/icon-new-yd.svg"
            alt="logo-yesdok-network"
            class="h-auto"
            width="131"
            height="56"
            style="visibility: hidden;"
            onload="this.style.visibility= 'visible'"
            @load="onImgLoad"
          >
        </div>
        <div class="block lg:hidden">
          <el-button v-click-outside="closeNavbar" :icon="`el-icon-${navbar ? 'close': 'arrow-down'}`" circle @click="navbar = !navbar" />
          <transition name="fade">
            <div v-show="navbar" class="absolute z-10 w-full bg-white left-0 mt-2 text-center">
              <div class="text-base py-3">
                Masuk sebagai
              </div>
              <div class="flex flex-wrap justify-around items-center pb-3">
                <el-dropdown class="dropdown-choosen mr-3" trigger="click" v-show="isFullyLoaded">
                  <div class="el-dropdown-link text-left py-5">
                    <div class="text-absolute text-base">
                      {{ choosenText }}
                    </div>
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <div v-for="(list, index) in listDropdown" :key="index">
                      <el-dropdown-item class="flex items-center">
                        <span @click="handleChoosenText(list)">
                          {{ list.text }}
                        </span>
                      </el-dropdown-item>
                    </div>
                  </el-dropdown-menu>
                </el-dropdown>
                <yes-button :disabled="!choosenPath" variant="success" class="py-3 px-12 relative text-base rounded-6" @click="handleRedirect">
                  MASUK
                </yes-button>
              </div>
            </div>
          </transition>
        </div>
        <div class="hidden lg:flex mt-5 md:mt-0 flex-nowrap justify-between items-center">
          <div class="mr-3 text-sm md:text-base">
            Masuk sebagai
          </div>
          <el-dropdown class="dropdown-choosen mr-3" trigger="click" v-show="isFullyLoaded">
            <div class="el-dropdown-link text-left py-5">
              <div class="text-absolute text-base">
                {{ choosenText }}
              </div>
            </div>
            <el-dropdown-menu slot="dropdown">
              <div v-for="(list, index) in listDropdown" :key="index">
                <el-dropdown-item class="flex items-center">
                  <span @click="handleChoosenText(list)">
                    {{ list.text }}
                  </span>
                </el-dropdown-item>
              </div>
            </el-dropdown-menu>
          </el-dropdown>
          <yes-button :disabled="!choosenPath" variant="success" class="py-3 px-12 relative text-base rounded-6" @click="handleRedirect">
            MASUK
          </yes-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import YesButton from './YesButton.vue'
export default {
  components: { YesButton },
  directives: {
    'click-outside': {
      bind: function bind (el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== 'function') {
          const compName = vNode.context.name
          let warn = '[Vue-click-outside:] provided expression \'' + binding.expression + '\' is not a function, but has to be'
          if (compName) {
            warn += 'Found in component \'' + compName + '\''
          }

          throw new Error(warn)
        }
        // Define Handler and cache it on the element
        const handler = function handler (e) {
          if (!el.contains(e.target) && el !== e.target) {
            binding.value(e)
          }
        }
        el.__vueClickOutside__ = handler

        // add Event Listeners
        document.addEventListener('click', handler)
      },

      unbind: function unbind (el, binding) {
        // Remove Event Listeners
        document.removeEventListener('click', el.__vueClickOutside__)
        el.__vueClickOutside__ = null
      }
    }
  },
  data () {
    return {
      listDropdown: [
        {
          text: 'Rumah Sakit',
          path: '?target=hospital'
        },
        {
          text: 'Klinik',
          path: '?target=clinic'
        },
        {
          text: 'Dokter',
          path: '?target=doctor'
        },
        {
          text: 'Psikolog',
          path: '?target=psychologist'
        }
      ],
      choosenText: 'Pilih',
      choosenPath: '',
      navbar: false,
      isFullyLoaded: false
    }
  },
  methods: {
    onImgLoad () {
      this.isFullyLoaded = true
    },
    handleRedirect () {
      if (this.choosenPath) {
        const path = process.env.LOGIN_URL + this.choosenPath
        window.open(path)
      }
    },
    handleChoosenText (choosen) {
      this.choosenText = choosen.text
      this.choosenPath = choosen.path
    },
    closeNavbar (openNavbar = false) {
      if (openNavbar) { return }
      this.navbar = false
    }
  }
}
</script>

<style lang="scss">
.dropdown-choosen {
  .el-dropdown-link {
    border: 1.42077px solid #26D226;
    box-sizing: border-box;
    border-radius: 7px;
    width: 160px;
    .text-absolute {
      position: absolute;
      top: 12px;
      bottom: 0;
      left: 13px;
      margin: auto;
    }
  }
}
</style>
